import React from 'react';

const TextInput = (props) => {
    return (
        <input {...props} />
    );
}

export default TextInput;
